import React, { useEffect, useRef, useState } from "react";
import api from "../../utils/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  empty,
  getTranslation,
  showCurrencySymbol,
  showTranslatedValue,
} from "../../helper/generalHelper";
import Pagination from "../../components/common/Pagination";
import { fetchStatuses } from "../../utils/fetcher";
import { useStatuses } from "../../hooks/useStatuses";
import { FaThLarge, FaList } from "react-icons/fa";

const PAYMENT_COMPLETED = 17;
const ORDER_COMPLETED = 10;

  const CreateOrder = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const apiPrefix = window.location.pathname.includes("restaurant-staff") ? "restaurant-staff" : "restaurant";
    const basePath = window.location.pathname.includes("restaurant-staff") ? "/restaurant-staff/employee" : "/restaurant";

  const [subcategories, setSubcategories] = useState([]);
  const { statuses, statusesLoading } = useStatuses();
  // const [statuses, setStatuses] = useState(()=> statuses);
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState(2);

  const [orderNote, setOrderNote] = useState("");
  const [extraTaxValue, setExtraTaxValue] = useState("");
  const [extraDiscountType, setExtraDiscountType] = useState("fixed");
  const [extraDiscountValue, setExtraDiscountValue] = useState("");
  const [otherCostValue, setOtherCostValue] = useState("");
  const [otherCostLabel, setOtherCostLabel] = useState("");

  const [orderStatus, setOrderStatus] = useState(1);
  const [paymentStatus, setPaymentStatus] = useState(18);
  const [paymentMethod, setPaymentMethod] = useState("");

  const [customerName, setCustomerName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");

  const [cart, setCart] = useState([]); // 🛒 global cart across all categories

  const prevPaymentStatus = useRef(paymentStatus);
  const prevOrderStatus = useRef(orderStatus);

  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const [view, setView] = useState(() => localStorage.getItem("preferred_menu_view") || "grid");

  useEffect(() => {
    localStorage.setItem("preferred_menu_view", view);
  }, [view]);

  const userDatas = JSON.parse(localStorage.getItem("userData")) || {};
  const restaurantId = userDatas?.restaurantId;
  const orderType = searchParams.get("type");
  const table = searchParams.get("tableNumber");
  const tableName = searchParams.get("tableName");

  useEffect(() => {
    // Logic for auto-status updates removed as requested
    prevPaymentStatus.current = paymentStatus;
    prevOrderStatus.current = orderStatus;
  }, [paymentStatus, orderStatus]);

  const fetchMenusByCategory = async (categoryId) => {
    try {
      setLoading(true);
      const response = await api.post(`${apiPrefix}/order/menus`, {
        category_id: categoryId,
        restaurantId,
      });

      // Just set the menus without quantity - cart handles quantities
      const fetchedMenus = response?.data || [];

      setMenus(fetchedMenus);
      setActiveCategory(categoryId);
      setCurrentPage(1);
    } catch (err) {
      console.error("Error fetching menus by category:", err);
    } finally {
      setLoading(false);
    }
  };

  // const loadStatuses = async (keys) => {
  //   try {
  //     const statuses = await fetchStatuses(keys);
  //     setStatuses(statuses);
  //   } catch (err) {
  //     console.error("Error fetching statuses", err);
  //   }
  // };

  console.log(statuses);

  useEffect(() => {
    setLoading(true);
    api
      .get(`${apiPrefix}/subcategory/all`, { params: { restaurantId } })
      .then((response) => {
        const subs = response?.data || [];
        setSubcategories(subs);
        if (subs.length > 0) {
          fetchMenusByCategory(subs[0].id);
        } else {
          setMenus([]);
          setActiveCategory(null);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching subcategories:", error);
        setLoading(false);
      });
  }, [restaurantId]);

  const cartItems = cart;

  // const handleProductClick = (productId) => {
  //   if (!orderType) return alert("Please select Takeaway or Dine-in first.");
  //   if (orderType === "table" && !table) return alert("Please select a table.");

  //   setMenus((prev) =>
  //     prev.map((m) => (m.id === productId ? { ...m, qty: m.qty + 1 } : m))
  //   );
  // };

  const handleProductClick = (productId) => {
    if (!orderType) return alert("Please select Takeaway or Dine-in first.");
    if (orderType === "table" && !table) return alert("Please select a table.");

    setCart((prevCart) => {
      const existing = prevCart.find((item) => item.id == productId);

      // If item exists in cart, just increment - we don't need product details
      if (existing) {
        return prevCart.map((item) =>
          item.id == productId ? { ...item, qty: item.qty + 1 } : item
        );
      }

      // Only if it's a new item, we need to find it in current menus
      const product = menus.find((m) => m.id == productId);
      if (!product) {
        console.log("Product not found in current category");
        return prevCart;
      }

      const cartItem = {
        id: product.id,
        price: product.price || 0,
        mrp: product.mrp || product.price || 0,
        has_tax: product.has_tax || 0,
        tax: product.tax || 0,
        menuImages: product.menuImages || [],
        translations: product.translations || {},
        qty: 1,
      };

      return [...prevCart, cartItem];
    });
  };

  // const handleRemoveItem = (productId) => {
  //   setMenus((prev) =>
  //     prev.map((m) =>
  //       m.id === productId ? { ...m, qty: Math.max(m.qty - 1, 0) } : m
  //     )
  //   );
  // };

  const handleRemoveItem = (productId) => {
    setCart((prevCart) =>
      prevCart
        .map((item) =>
          item.id === productId
            ? { ...item, qty: Math.max(item.qty - 1, 0) }
            : item
        )
        .filter((item) => item.qty > 0)
    );
    // Remove the setMenus call - we don't sync with menus anymore
  };

  const getItemCount = (productId) =>
    cart.find((item) => item.id === productId)?.qty || 0;

  const mrpTotal = cartItems.reduce(
    (acc, item) => acc + item.mrp * item.qty,
    0
  );

  const itemTaxAmount = cartItems.reduce((acc, item) => {
    if (item.has_tax === 1) {
      return acc + (item.price * item.qty * Number(item.tax)) / 100;
    }
    return acc;
  }, 0);

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.qty,
    0
  );

  const extraDiscountAmount =
    extraDiscountType === "percentage"
      ? (subtotal * Number(extraDiscountValue)) / 100
      : Number(extraDiscountValue);

  const extraTaxAmount = (subtotal * Number(extraTaxValue)) / 100;

  const totalTax = itemTaxAmount + extraTaxAmount;
  const total =
    subtotal - extraDiscountAmount + totalTax + Number(otherCostValue);

  const handlePlaceOrder = async () => {
    if (cartItems.length === 0) return alert("Cart is empty.");
    if (paymentStatus != PAYMENT_COMPLETED && !customerName) return toast.error("Customer name is required for unpaid orders.");
    if (paymentStatus === PAYMENT_COMPLETED && !paymentMethod) {
      return toast.error("Please select a payment method.");
    }

    try {
// Token is handled securely via HttpOnly cookies

      const payload = {
        customerName: customerName,
        customerMobile: customerMobile,
        customerEmail: customerEmail,
        orderDate: new Date().toISOString().split("T")[0],
        orderTime: new Date().toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }),
        orderType: orderType === "table" ? "table" : orderType,
        orderStatus,
        paymentStatus,
        paymentMode: paymentStatus == PAYMENT_COMPLETED ? paymentMethod : "cash",
        tableNumber: orderType === "table" ? table : null,
        extraTax: Number(extraTaxValue) || 0,
        extraDiscountType: extraDiscountType,
        extraDiscount: Number(extraDiscountValue) || 0,
        otherCost: Number(otherCostValue) || 0,
        otherCostType: otherCostLabel || "",
        note: orderNote || "",
        menus: cartItems.map((item) => ({
          menuId: item.id,
          quantity: item.qty,
        })),
      };

      const response = await api.post(`${apiPrefix}/order/new`, payload);

      if (response.success) {
        toast.success(response.message);
        navigate(`${basePath}/orders`);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("Error placing order:", err.response || err);
      alert("Failed to place order. Try again.");
    }
  };

  // PAGINATION
  const totalPages = Math.ceil(menus.length / itemsPerPage);
  const paginatedMenus = menus.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="flex flex-col bg-gray-50 relative mb-16 lg:mb-0">
      {/* Sticky Search Bar */}
      <div className="p-4 bg-white border-b sticky top-0 z-20 flex items-center justify-between gap-4">
        <input
          type="text"
          placeholder="🔍 Search for a dish..."
          className="w-full p-3 rounded-xl border text-sm focus:ring-2 focus:ring-rose-400 outline-none"
        />
        {/* View Toggle */}
        <div className="flex bg-gray-100 p-1 rounded-lg shrink-0">
          <button
            onClick={() => setView("grid")}
            className={`p-2 rounded-md transition ${view === "grid" ? "bg-white text-rose-600 shadow-sm" : "text-gray-500 hover:bg-gray-200"}`}
            title="Grid View"
          >
            <FaThLarge />
          </button>
          <button
            onClick={() => setView("list")}
            className={`p-2 rounded-md transition ${view === "list" ? "bg-white text-rose-600 shadow-sm" : "text-gray-500 hover:bg-gray-200"}`}
            title="List View"
          >
            <FaList />
          </button>
        </div>
      </div>

      {/* Order Info */}
      <div className="px-4 py-2 text-sm text-gray-700 bg-white shadow-sm sticky top-[4rem] z-10">
        <p>
          Order Type:{" "}
          <span className="font-semibold capitalize">
            {orderType || "Not Selected"}
          </span>
        </p>
        {orderType === "table" && table && (
          <p>
            Table Number:{" "}
            <span className="font-semibold">
              {tableName || String(table).padStart(2, "0")}
            </span>
          </p>
        )}
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden space-y-4 md:space-y-0">
        {/* Category Sidebar */}
       {/* Category Sidebar */}
<div className="md:w-full flex-shrink-0 bg-white border-b md:border-b-0 md:border-r overflow-x-auto md:overflow-y-auto flex flex-nowrap md:flex-row gap-2 px-2 py-2 shadow-sm">
  {subcategories.map((cat) => (
    <div
      key={cat.id}
      onClick={() => fetchMenusByCategory(cat.id)}
      title={cat.translations?.en?.name || "Unnamed"}
      className={`flex flex-col items-center gap-1 p-2 rounded-lg cursor-pointer transition shrink-0 min-w-[80px] max-w-[140px] ${
        activeCategory === cat.id
          ? "bg-rose-600 text-white"
          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
      }`}
    >
      <span className="text-center text-xs font-medium  truncate w-full">
        {cat.translations?.en?.name || "Unnamed"}
      </span>
    </div>
  ))}
</div>

        {/* Product Grid */}
        <div className="w-full p-4">
          {subcategories.length === 0 && !loading ? (
            <div className="flex flex-col items-center justify-center py-20 bg-white rounded-2xl shadow-sm border border-gray-100">
              <div className="text-4xl mb-3">🍽️</div>
              <h3 className="text-lg font-bold text-gray-800">No Categories Found</h3>
              <p className="text-gray-500 text-sm text-center max-w-sm mt-1">
                Please create a menu category first to start taking orders.
              </p>
            </div>
          ) : (
            <div className={`w-full ${view === 'list' ? 'bg-white rounded-xl shadow-sm border border-gray-100 overflow-x-auto' : ''}`}>
              {view === "list" ? (
                <table className="w-full text-left border-collapse whitespace-nowrap min-w-max">
                  <thead>
                    <tr className="bg-gray-50 border-b border-gray-100 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      <th className="px-6 py-4">Item</th>
                      <th className="px-6 py-4">Price</th>
                      <th className="px-6 py-4 text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {loading ? (
                      [...Array(5)].map((_, idx) => (
                        <tr key={idx}>
                          <td colSpan="3" className="px-6 py-4">
                            <div className="animate-pulse bg-gray-200 h-12 rounded-xl"></div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      paginatedMenus.map((product) => (
                        <tr 
                          key={product.id} 
                          onClick={() => handleProductClick(product.id)}
                          className="hover:bg-gray-50 transition cursor-pointer"
                        >
                          <td className="px-6 py-4">
                            <div className="flex items-center">
                              <div className="h-12 w-12 flex-shrink-0 rounded-lg bg-gray-100 overflow-hidden mr-4">
                                <img
                                  src={product.menuImages?.[0]}
                                  alt={product.translations?.en?.title}
                                  className="h-full w-full object-cover"
                                />
                              </div>
                              <div className="text-sm font-bold text-gray-900 truncate max-w-xs" title={product.translations?.en?.title}>
                                {showTranslatedValue(product, "title")}
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-rose-600 font-bold text-sm">
                            {showCurrencySymbol(product.price)}
                          </td>
                          <td className="px-6 py-4 text-center">
                            {getItemCount(product.id) > 0 ? (
                              <div className="inline-block bg-green-100 text-green-700 font-bold text-xs px-3 py-1 rounded-full shadow-sm">
                                {getItemCount(product.id)} in cart
                              </div>
                            ) : (
                              <span className="text-gray-400 text-xs font-medium border border-gray-200 px-3 py-1 rounded-full">Add</span>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              ) : (
                <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
                  {loading
                    ? [...Array(8)].map((_, idx) => (
                        <div
                          key={idx}
                          className="animate-pulse bg-gray-200 h-56 rounded-xl"
                        ></div>
                      ))
                    : paginatedMenus.map((product) => (
                        <div
                          key={product.id}
                          onClick={() => handleProductClick(product.id)}
                          className="relative rounded-xl bg-white shadow hover:shadow-lg cursor-pointer transition h-56 flex flex-col"
                        >
                          <img
                            src={product.menuImages?.[0]}
                            alt={product.translations?.en?.title}
                            className="w-full h-28 object-cover rounded-t-xl"
                          />
                          <div className="p-3 flex flex-col flex-1 justify-between">
                            <p
                              className="text-sm font-semibold text-gray-800 truncate"
                              title={product.translations?.en?.title}
                            >
                              {showTranslatedValue(product, "title")}
                            </p>
                            <p className="text-rose-600 font-bold text-sm mt-1">
                              {showCurrencySymbol(product.price)}
                            </p>
                          </div>
                          {getItemCount(product.id) > 0 && (
                            <span className="absolute top-2 right-2 bg-green-600 text-white text-xs px-2 py-1 rounded-full shadow">
                              x{getItemCount(product.id)}
                            </span>
                          )}
                        </div>
                      ))}
                </div>
              )}
            </div>
          )}

          {/* Pagination */}
          {menus.length > 0 && (
            <div className="mt-6 bg-white rounded-xl shadow-sm p-2">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={menus.length}
                pageSize={itemsPerPage}
                onPageChange={setCurrentPage}
                onPageSizeChange={setItemsPerPage}
              />
            </div>
          )}
        </div>

        {/* Cart Section Below */}

        {/* Cart Section Below */}
        <div className="w-full bg-white border-t md:border-l p-4 lg:pe-[5%] overflow-y-auto">
          <h2 className="text-xl font-bold mb-4 text-center">Cart Summary</h2>

          {cartItems.length === 0 ? (
            <p className="text-center text-gray-500">Your cart is empty.</p>
          ) : (
            <div className="space-y-4">
              {cartItems.map((item) => {
                const quantity = item.qty;
                const price = item.price;
                const mrp = item.mrp || price;
                const savedAmount = (mrp - price) * quantity;
                const itemTax =
                  item.has_tax === 1
                    ? (price * quantity * Number(item.tax)) / 100
                    : 0;
                const itemTotal = price * quantity + itemTax;

                return (
                  <div
                    key={item.id}
                    className="flex items-start gap-3 border-b pb-3 pt-2"
                  >
                    {/* Product Image */}
                    <img
                      src={item.menuImages?.[0]}
                      alt={item.translations?.en?.title}
                      className="w-14 h-14 object-cover rounded"
                    />

                    {/* Info Section */}
                    <div className="flex-1">
                      {/* Product Title */}
                      <p className="md:text-xl capitalize font-semibold text-gray-800 mr-2">
                        {item.translations?.en?.title}
                        <span className="ml-2 text-rose-600 font-medium">
                          × {quantity}
                        </span>
                      </p>
                      {/* Pricing Details */}
                      <div className="text-xs text-gray-600 mt-1 space-y-1">
                        {/* Price and MRP */}
                        <div className="flex items-center gap-2">
                          <span className="line-through text-gray-400">
                            {showCurrencySymbol(mrp)}
                          </span>
                          <span className="text-rose-600 font-medium">
                            {showCurrencySymbol(price)} × {quantity}
                          </span>
                        </div>

                        {/* Savings */}
                        {mrp > price && (
                          <p className="text-green-600">
                            You Saved: {showCurrencySymbol(savedAmount)}
                          </p>
                        )}

                        {/* Tax Info */}
                        {item.has_tax === 1 && (
                          <p className="text-amber-600">
                            Tax ({item.tax}%): {showCurrencySymbol(itemTax)}
                          </p>
                        )}

                        {/* Subtotal for this item */}
                        <p className="text-gray-700 font-medium">
                          Subtotal: {showCurrencySymbol(itemTotal)}
                        </p>
                      </div>
                    </div>

                    {/* Quantity Buttons */}
                    <div className="flex flex-col items-center gap-1">
                      <button
                        onClick={() => handleProductClick(item.id)}
                        className="px-2 py-1 bg-gray-200 rounded text-sm"
                      >
                        +
                      </button>
                      <span>{item.qty}</span>
                      <button
                        onClick={() => handleRemoveItem(item.id)}
                        className="px-2 py-1 bg-gray-200 rounded text-sm"
                      >
                        -
                      </button>
                    </div>
                  </div>
                );
              })}

              {/* Input Fields Below Cart */}
              <div className="pt-4 border-t text-sm space-y-3">
                <div className="space-y-4 mt-6">
                  {/* Order Note */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Order Note
                    </label>
                    <textarea
                      value={orderNote}
                      onChange={(e) => setOrderNote(e.target.value)}
                      rows={2}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500 resize-none"
                      placeholder="Add any special instructions..."
                    />
                  </div>

                  {/* Extra Tax */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                    <label className="text-sm font-medium text-gray-700 w-32">
                      Tax (%)
                    </label>
                    <input
                      type="number"
                      value={extraTaxValue}
                      onChange={(e) => setExtraTaxValue(e.target.value)}
                      className="w-full sm:w-32 border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500"
                      placeholder="0"
                      autoComplete="off"
                    />
                  </div>

                  {/* Discount Section */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                    <label className="text-sm font-medium text-gray-700 w-32">
                      Extra Discount
                    </label>
                    <div className="flex gap-2 w-full">
                      <select
                        value={extraDiscountType}
                        onChange={(e) => setExtraDiscountType(e.target.value)}
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500 w-1/2 sm:w-36"
                      >
                        <option value="fixed">Fixed</option>
                        <option value="percentage">Percentage</option>
                      </select>
                      <input
                        type="number"
                        value={extraDiscountValue}
                        onChange={(e) => setExtraDiscountValue(e.target.value)}
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500 w-full"
                        placeholder="0"
                        autoComplete="off"
                      />
                    </div>
                  </div>

                  {/* Other Cost */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                    <label className="text-sm font-medium text-gray-700 w-32">
                      Other Cost
                    </label>
                    <div className="flex gap-2 w-full">
                      <input
                        type="text"
                        placeholder="Label"
                        value={otherCostLabel}
                        onChange={(e) => setOtherCostLabel(e.target.value)}
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500 w-full"
                        autoComplete="off"
                      />
                      <input
                        type="number"
                        placeholder={localStorage.getItem("currency") || "INR"}
                        value={otherCostValue}
                        onChange={(e) => setOtherCostValue(e.target.value)}
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500 w-28"
                        autoComplete="off"
                      />
                    </div>
                  </div>

                  {/* Order Status */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                    <label className="text-sm font-medium text-gray-700 w-32">
                      Order Status
                    </label>
                    <select
                      value={orderStatus}
                      onChange={(e) => setOrderStatus(Number(e.target.value))}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500"
                    >
                      {(statuses?.orders || [])
                        .filter(status => [1, 3, 4, 6, 10].includes(Number(status.statusId)))
                        .map((status) => (
                        <option key={status.statusId} value={status.statusId}>
                          {getTranslation(status.translations)?.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Payment Status */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                    <label className="text-sm font-medium text-gray-700 w-32">
                      Payment Status
                    </label>
                    <select
                      value={paymentStatus}
                      onChange={(e) => {
                        const newStatus = Number(e.target.value);
                        setPaymentStatus(newStatus);
                        if (newStatus === PAYMENT_COMPLETED && !paymentMethod) {
                          setPaymentMethod("cash");
                        }
                      }}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500"
                    >
                      {(statuses?.payment || []).map((status) => (
                        <option key={status.statusId} value={status.statusId}>
                          {getTranslation(status.translations)?.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {paymentStatus === PAYMENT_COMPLETED && (
                    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                      <label className="text-sm font-medium text-gray-700 w-32">
                        Payment Method
                      </label>
                      <select
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500"
                      >
                        <option value="">Select Payment Method</option>
                        <option value="cash">Cash</option>
                        <option value="upi">UPI</option>
                        <option value="card">Card</option>
                      </select>
                    </div>
                  )}
                </div>

                {/* Totals */}

                  {/* Customer Details */}
                  <div className="pt-4 border-t space-y-3">
                    <h3 className="text-sm font-semibold text-gray-800">Customer Details</h3>
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Customer Name {paymentStatus != PAYMENT_COMPLETED && <span className="text-red-500">*</span>}
                      </label>
                      <input
                        type="text"
                        value={customerName}
                        onChange={(e) => setCustomerName(e.target.value)}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500"
                        placeholder="Enter customer name"
                        required
                      />
                    </div>
                    <div className="flex gap-2">
                      <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Mobile Number
                        </label>
                        <input
                          type="tel"
                          value={customerMobile}
                          onChange={(e) => setCustomerMobile(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500"
                          placeholder="Mobile"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                          Email
                        </label>
                        <input
                          type="email"
                          value={customerEmail}
                          onChange={(e) => setCustomerEmail(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-rose-500 focus:border-rose-500"
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Cart Totals Summary */}
                  <div className="pt-5 border-t mt-5 text-sm space-y-3">
                  {/* MRP Total */}
                  <div className="flex justify-between text-gray-500">
                    <span>MRP Total</span>
                    <span className="text-primary line-through">
                      {showCurrencySymbol(mrpTotal)}
                    </span>
                  </div>

                  {/* You Saved */}
                  {mrpTotal > subtotal && (
                    <div className="flex justify-between text-emerald-600 font-medium">
                      <span>You Saved</span>
                      <span>-{showCurrencySymbol(mrpTotal - subtotal)}</span>
                    </div>
                  )}

                  {/* Subtotal */}
                  <div className="flex justify-between text-gray-700 font-medium">
                    <span>Subtotal</span>
                    <span>{showCurrencySymbol(subtotal)}</span>
                  </div>

                  {/* Discount */}
                  {extraDiscountAmount > 0 && (
                    <div className="flex justify-between text-gray-600">
                      <span>Discount</span>
                      <span className="text-green-500">
                        - {showCurrencySymbol(extraDiscountAmount)}
                      </span>
                    </div>
                  )}

                  {/* Item Tax */}
                  {itemTaxAmount > 0 && (
                    <div className="flex justify-between text-gray-600">
                      <span>Item Tax</span>
                      <span className="text-orange-500">
                        {showCurrencySymbol(itemTaxAmount)}
                      </span>
                    </div>
                  )}

                  {/* Tax */}
                  {extraTaxAmount > 0 && (
                    <div className="flex justify-between text-gray-600">
                      <span>Tax ({extraTaxValue || 0}%)</span>
                      <span className="text-orange-500">
                        {showCurrencySymbol(extraTaxAmount)}
                      </span>
                    </div>
                  )}

                  {/* Other Cost */}
                  {Number(otherCostValue) > 0 && (
                    <div className="flex justify-between text-gray-600">
                      <span>{otherCostLabel || "Other Cost"}</span>
                      <span className="text-orange-500">
                        {showCurrencySymbol(otherCostValue)}
                      </span>
                    </div>
                  )}

                  {/* Divider */}
                  <hr className="my-2 border-gray-200" />

                  {/* Total */}
                  <div className="flex justify-between items-center bg-gray-100 px-3 py-2 rounded-lg text-base font-semibold text-gray-800 border border-gray-200">
                    <span>Total</span>
                    <span>{showCurrencySymbol(total)}</span>
                  </div>

                  {/* CTA Button */}
                  <button
                    onClick={handlePlaceOrder}
                    className="w-full bg-rose-600 hover:bg-rose-700 text-white text-sm font-semibold py-2.5 rounded-lg shadow-md transition-all duration-200"
                  >
                    ✅ Proceed to Checkout
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateOrder;
